import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import Slider from 'rc-slider';
import { isArray } from '@grandvisionhq/utils';
import Price from '../Price/Price.js';

const TooltipLabel = ({ currency , renderNumber , value , side  })=>/*#__PURE__*/ React.createElement("div", {
        className: `tooltip__label tooltip__label--${side}`,
        "data-t": `tooltip-label-${side}`
    }, currency ? /*#__PURE__*/ React.createElement(Price, {
        value: renderNumber(value),
        currency: currency,
        centAmount: false
    }) : renderNumber(value))
;
const defaultValueInitial = [];
const renderNumberInitial = (v)=>v
;
const RangeSlider = ({ min , max , defaultValue =defaultValueInitial , value: value1 , onChange , onChangeComplete , currency , renderNumber =renderNumberInitial  })=>{
    const handleOnChange = (value)=>{
        if (!isArray(value)) return;
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
    };
    const handleOnChangeComplete = (value)=>{
        if (!isArray(value)) return;
        onChangeComplete === null || onChangeComplete === void 0 ? void 0 : onChangeComplete(value);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "range-slider",
        "data-t": "range-slider"
    }, /*#__PURE__*/ React.createElement(Slider, swcHelpers.extends({}, value1 ? {
        value: value1
    } : {
        defaultValue
    }, {
        range: true,
        min: min,
        max: max,
        onChangeComplete: handleOnChangeComplete,
        onChange: handleOnChange,
        allowCross: false
    })), /*#__PURE__*/ React.createElement("div", {
        className: "tooltip"
    }, /*#__PURE__*/ React.createElement(TooltipLabel, {
        currency: currency,
        value: (value1 || defaultValue)[0],
        renderNumber: renderNumber,
        side: "left"
    }), /*#__PURE__*/ React.createElement(TooltipLabel, {
        currency: currency,
        value: (value1 || defaultValue)[1],
        renderNumber: renderNumber,
        side: "right"
    })));
};

export { RangeSlider };
//# sourceMappingURL=RangeSlider.js.map
